/**
 * Пустой провайдер. Нужен, чтобы «аналитики нет» было честным состоянием,
 * а не веткой `if (provider)` в каждом вызове ядра.
 *
 * Срабатывает на инстансе без ключей и при REACT_APP_ANALYTICS=none.
 */
export const key = 'noop';

export function isConfigured() { return true; }
export function init() {}
export function identify() {}
export function reset() {}
export function capture() {}
export function pageview() {}

export const hasNativeAutocapture = true;  // делегат не нужен: слать некуда
export const hasNativePageviews = true;
